import type { LookStyle } from '@/entities/appearance';

/** The styles a board tile / card may use (columns offer more). */
export const TILE_STYLES: readonly LookStyle[] = [
  'header',
  'border',
  'accent',
  'soft',
  'solid',
  'gradient',
  'pattern',
];
